 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1E9780806537399_COV01 from '@/components/Book1/e9780806537399_cov01'
 import BOOK1E9780806537399_TP01 from '@/components/Book1/e9780806537399_tp01'
 import BOOK1E9780806537399_FRW01 from '@/components/Book1/e9780806537399_frw01'
 import BOOK1E9780806537399_FM01 from '@/components/Book1/e9780806537399_fm01'
 import BOOK1E9780806537399_FM02 from '@/components/Book1/e9780806537399_fm02'
 import BOOK1E9780806537399_C01 from '@/components/Book1/e9780806537399_c01'
 import BOOK1E9780806537399_C02 from '@/components/Book1/e9780806537399_c02'
 import BOOK1E9780806537399_C03 from '@/components/Book1/e9780806537399_c03'
 import BOOK1E9780806537399_C04 from '@/components/Book1/e9780806537399_c04'
 import BOOK1E9780806537399_C05 from '@/components/Book1/e9780806537399_c05'
 import BOOK1E9780806537399_FTN01 from '@/components/Book1/e9780806537399_ftn01'
 import BOOK2XHTMLCOVER from '@/components/Book2/xhtml/cover'
 import BOOK2XHTMLTITLE from '@/components/Book2/xhtml/title'
 import BOOK2XHTMLCHAPTER001 from '@/components/Book2/xhtml/chapter001'
 import BOOK2XHTMLCHAPTER002 from '@/components/Book2/xhtml/chapter002'
 import BOOK2XHTMLCHAPTER003 from '@/components/Book2/xhtml/chapter003'
 import BOOK2XHTMLCHAPTER004 from '@/components/Book2/xhtml/chapter004'
 import BOOK2XHTMLCHAPTER005 from '@/components/Book2/xhtml/chapter005'
 import BOOK2XHTMLCHAPTER006 from '@/components/Book2/xhtml/chapter006'
 import BOOK2XHTMLCHAPTER007 from '@/components/Book2/xhtml/chapter007'
 import BOOK2XHTMLCHAPTER008 from '@/components/Book2/xhtml/chapter008'
 import BOOK2XHTMLENDMATTER01 from '@/components/Book2/xhtml/endmatter01'
 import BOOK2XHTMLENDMATTER02 from '@/components/Book2/xhtml/endmatter02'
 import BOOK3COVER from '@/components/Book3/cover'
 import BOOK3UNTITLED1 from '@/components/Book3/Untitled-1'
 import BOOK3UNTITLED11 from '@/components/Book3/Untitled-1-1'
 import BOOK3UNTITLED12 from '@/components/Book3/Untitled-1-2'
 import BOOK3UNTITLED13 from '@/components/Book3/Untitled-1-3'
 import BOOK3UNTITLED14 from '@/components/Book3/Untitled-1-4'
 import BOOK3UNTITLED15 from '@/components/Book3/Untitled-1-5'
 import BOOK3UNTITLED16 from '@/components/Book3/Untitled-1-6'
 import BOOK3UNTITLED17 from '@/components/Book3/Untitled-1-7'
 import BOOK3UNTITLED18 from '@/components/Book3/Untitled-1-8'
 import BOOK3UNTITLED18A from '@/components/Book3/Untitled-1-8a'
 import BOOK3UNTITLED19 from '@/components/Book3/Untitled-1-9'
 import BOOK3UNTITLED110 from '@/components/Book3/Untitled-1-10'
 import BOOK3UNTITLED111 from '@/components/Book3/Untitled-1-11'
 import BOOK3UNTITLED112 from '@/components/Book3/Untitled-1-12'
 import BOOK3UNTITLED113 from '@/components/Book3/Untitled-1-13'
 import BOOK3UNTITLED113A from '@/components/Book3/Untitled-1-13a'
 import BOOK3UNTITLED114 from '@/components/Book3/Untitled-1-14'
 import BOOK3UNTITLED115 from '@/components/Book3/Untitled-1-15'
 import BOOK3UNTITLED116 from '@/components/Book3/Untitled-1-16'
 import BOOK3UNTITLED117 from '@/components/Book3/Untitled-1-17'
 import BOOK3UNTITLED118 from '@/components/Book3/Untitled-1-18'
 import BOOK3UNTITLED119 from '@/components/Book3/Untitled-1-19'
 import BOOK4E9780806537191_COV01 from '@/components/Book4/e9780806537191_cov01'
 import BOOK4E9780806537191_TP01 from '@/components/Book4/e9780806537191_tp01'
 import BOOK4E9780806537191_C01 from '@/components/Book4/e9780806537191_c01'
 import BOOK4E9780806537191_BM01 from '@/components/Book4/e9780806537191_bm01'
 import LOVE_2 from '@/components/love_2'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONBACKAD from '@/components/Comon/backad'
 import COMONPHILOSOPHICALLIBRARY from '@/components/Comon/PhilosophicalLibrary'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/e9780806537399_cov01",
 			"name" : "Book1/e9780806537399_cov01",
 			"component" : BOOK1E9780806537399_COV01
 		},
 		{
 			"path" : "/Book1/e9780806537399_tp01",
 			"name" : "Book1/e9780806537399_tp01",
 			"component" : BOOK1E9780806537399_TP01
 		},
 		{
 			"path" : "/Book1/e9780806537399_frw01",
 			"name" : "Book1/e9780806537399_frw01",
 			"component" : BOOK1E9780806537399_FRW01
 		},
 		{
 			"path" : "/Book1/e9780806537399_fm01",
 			"name" : "Book1/e9780806537399_fm01",
 			"component" : BOOK1E9780806537399_FM01
 		},
 		{
 			"path" : "/Book1/e9780806537399_fm02",
 			"name" : "Book1/e9780806537399_fm02",
 			"component" : BOOK1E9780806537399_FM02
 		},
 		{
 			"path" : "/Book1/e9780806537399_c01",
 			"name" : "Book1/e9780806537399_c01",
 			"component" : BOOK1E9780806537399_C01
 		},
 		{
 			"path" : "/Book1/e9780806537399_c02",
 			"name" : "Book1/e9780806537399_c02",
 			"component" : BOOK1E9780806537399_C02
 		},
 		{
 			"path" : "/Book1/e9780806537399_c03",
 			"name" : "Book1/e9780806537399_c03",
 			"component" : BOOK1E9780806537399_C03
 		},
 		{
 			"path" : "/Book1/e9780806537399_c04",
 			"name" : "Book1/e9780806537399_c04",
 			"component" : BOOK1E9780806537399_C04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js